import { render } from "./OvDocumentsModal.vue?vue&type=template&id=5c5cfecc&scoped=true"
import script from "./OvDocumentsModal.vue?vue&type=script&lang=js"
export * from "./OvDocumentsModal.vue?vue&type=script&lang=js"

import "./OvDocumentsModal.vue?vue&type=style&index=0&id=5c5cfecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5cfecc"],['__file',"src/components/OvDocumentsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c5cfecc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c5cfecc', __exports__)) {
    api.reload('5c5cfecc', __exports__)
  }
  
  module.hot.accept("./OvDocumentsModal.vue?vue&type=template&id=5c5cfecc&scoped=true", () => {
    api.rerender('5c5cfecc', render)
  })

}


export default __exports__